// extracted by mini-css-extract-plugin
export default {"loader_container":"MediumLoader_loader_container__Fv8x6","loader":"MediumLoader_loader__oTNu+","spinner-c7wet2":"MediumLoader_spinner-c7wet2__DKXNb"};